import { toast } from 'react-toastify';
import appApi from '../../../../../../../../api/app-api';
import { HttpStatusCode } from 'axios';
import globalCourseStore from '../../../../../../../../stores/global-course-store';

export const assignmentFileDelete = async (
  programId: number | undefined,
  courseId: number | undefined,
  assignmentId: number | undefined,
  setLoading: (loading: boolean) => any,
) => {
  try {
    if (!programId || !courseId || !assignmentId) {
      toast.warn(
        'לא ניתן לאתר את המזהה של התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }

    setLoading(true);
    const res = await appApi.deleteAssignmentFile(
      programId,
      courseId,
      assignmentId,
    );

    setLoading(false);

    if (res.status === HttpStatusCode.Ok) {
      globalCourseStore.updateCourseDetails(
        courseId,
        res.data.body.metadata,
        res.data.body.details,
      );
    }
  } catch (e) {
    setLoading(false);
    console.error(
      `assignmentFileDelete is failed with the programId: ${programId}, courseId: ${courseId}, assignmentId: ${assignmentId} with the error: ${e}`,
    );

    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים');
  }
};
